module.exports = __webpack_public_path__ + "assets/img/stepIcon1@2x.4cf78038.png";